export default __webpack_public_path__ + "fa26ea42a62be46ee67e10630877125a.png";